import membersTemplate from './members.html';

class MembersController {
  static $inject = ['MemberModal', 'AuthService', 'Organization'];

  me: any;
  organization: any;
  orgMembers: any[];

  constructor(
    private MemberModal,
    private AuthService,
    private Organization,
  ) {}

  $onInit() {
    //TODO Should retrieve the organization shortName from the route parameters
    this.AuthService.me()
      .then((me) => {
        this.me = me;
        this.organization = me.organizations[me.organizations.length - 1];

        return this.Organization.getMembers(this.organization.shortName);
      })
      .then((orgMembers) => {
        this.orgMembers = orgMembers;
      });
  }

  addMember() {
    this.MemberModal.addMember().then((member) => {
      const newOrgMember = {
        member,
        role: 'Member',
      };

      this.Organization.addMember(
        this.organization.shortName,
        newOrgMember,
      ).then((orgMember) => {
        this.orgMembers.push(orgMember);
      });
    });
  }

  removeMember(orgMember) {
    const idx = this.orgMembers.indexOf(orgMember);
    this.orgMembers.splice(idx, 1);
    this.Organization.removeMember(this.organization.shortName, orgMember);
  }

  updateRole(orgMember) {
    this.Organization.updateRole(this.organization.shortName, orgMember);
  }
}

export const MembersComponent = {
  template: membersTemplate,
  controller: MembersController,
};
